// extracted by mini-css-extract-plugin
module.exports = {"container":"JZx2BjwQcQ4BEoc2lU9he","subline":"JXhEOjwPK5Uaa4YZMFxxw","duration":"_23KnVv12pEhsaR7p6Q_LIb","headline":"_2ScqvzHOI9kr9HZfdGfQDn","text":"_3qaHMBKk3nWIuOecO6StH0"};